<template>
  <section class="video">
    <video
      x5-video-player-type="h5"
      :preload="preload"
      :loop="loop"
      :playsinline="playsinline"
      :autoplay="autoplay"
      :muted="muted"
      :controls="controls"
      :poster="poster">
      <source :src="src" :type="type">
    </video>
    <p class="description" v-if="config.attrs.description">
      {{ config.attrs.description }}
    </p>
  </section>
</template>

<script>
export default {
  components: {},
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    preload: {
      type: String,
      default: 'auto'
    },
    type: {
      type: String,
      default: 'video/mp4'
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    playsinline: {
      type: Boolean,
      default: true
    },
    muted: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Boolean,
      default: true
    },
    loop:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    poster(){
      return this.config.attrs.poster;
    },
    src(){
      return this.config.attrs.src;
    }
  },
  mounted(){
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/standard';

.video {
  video {
    display: block;
    width: 100%;
  }
}
</style>